import React, { useState } from 'react';
import { Text, Button, Input, Header, BackButton } from 'ui';
import { useAuth, createPage, updateCampaign } from 'api';
import { useHistory, useParams } from 'react-router-dom';

export default function CreatePage(props) {
  const history = useHistory();
  const auth = useAuth();
  const {campaignId} = useParams();
  const [name, setName] = useState("");
  
  async function create() {
    const page = await createPage(auth.user.companyId, {name, campaignId});
    await updateCampaign(auth.user.companyId, campaignId, {pageId:page.id});
    history.replace(`/pages/${page.id}`);
  }
  
  return (
    <div>
      <Header>
        <BackButton/> <Text large light style={{flex:1}}>Create a Landing Page</Text>
      </Header>
      <div style={{padding:"100px 24px 40px 24px"}}>
        <div style={{maxWidth:600, margin:'0 auto'}}>
          <Text large light block style={{marginBottom:16}}>Name your Landing Page</Text>
          <Input 
            large
            value={name} 
            onChange={setName}
            style={{marginBottom:16}}
          />
          <div>
            <Button onClick={create} label="NEXT" small white backgroundColor="#243746"/>
            <Button onClick={() => history.goBack()} label="Cancel" small/>
          </div>
        </div>
      </div>
    </div>
  );
}